import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStepArrow = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 43,
	height: 38,
	viewBox: "0 0 43 38",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M24.9795 35.8637C23.447 38.5663 19.553 38.5663 18.0205 35.8637L1.07125 5.97304C-0.440788 3.30649 1.48537 3.39163e-07 4.55078 7.11768e-08L38.4492 -2.89232e-06C41.5146 -3.1603e-06 43.4408 3.30648 41.9287 5.97303L24.9795 35.8637Z",
		fill: "#002E5F"
	})
});
const ForwardRef = forwardRef(SvgStepArrow);
export default ForwardRef;
